import React, { useContext, useEffect, useState } from 'react';
import { displayContext } from '@/components/pages/assessments/context/display.context';

const QuestionInteger = ({ question, answer, setAnswer, setQuestionComplete, previewOnly = false }) => {
  const { css } = useContext(displayContext);
  const [value, setValue] = useState(answer);

  const required = !!question.required;

  const handleChange = (val) => {
    if (previewOnly) return;
    const n = parseInt(val);
    if (question.max_value || question.max_value === 0) {
      if (n > question.max_value) return;
    }
    if (question.min_value || question.mmin_value === 0) {
      if (n < question.min_value) return;
    }
    setValue(n);
  };

  useEffect(() => {
    if (!previewOnly) {
      setQuestionComplete(!required || Number.isInteger(value));
      setAnswer(value);
    }
  }, [value, previewOnly]);

  return (
    <>
      <div className="question-input question-integer">
        <input
          type="number"
          step={1}
          className={css('text-input')}
          onChange={(e) => handleChange(e.target.value)}
          value={value}
          disabled={previewOnly}
          readOnly={previewOnly}
        />
      </div>
    </>
  );
};

export default QuestionInteger;
